import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const supportedDateFormats = ['DD-MM-YYYY', 'YYYY-MM-DD', 'MM/DD/YYYY'];

export const formatPodDate = (value: string): string => {
  const parsed = supportedDateFormats
    .map(format => dayjs(value, format, true))
    .find(date => date.isValid());

  if (!parsed) {
    throw new Error(`Invalid POD delivery date: ${value}`);
  }

  return parsed.format('YYYY-MM-DD');
};
